<div class="ld2-wrapper" *ngIf="isLoading" role="status" aria-label="Chargement du tableau en cours…" aria-live="polite">

  <!-- ── En-tête skeleton ───────────────────────────────────────────────── -->
  <div class="ld2-header">
    <div class="ld2-header__col ld2-header__col--main">
      <div class="ld2-bone ld2-bone--header" style="width: 120px;"></div>
    </div>
    <div class="ld2-header__col ld2-header__col--date">
      <div class="ld2-bone ld2-bone--header" style="width: 60px;"></div>
    </div>
    <div class="ld2-header__col ld2-header__col--date">
      <div class="ld2-bone ld2-bone--header" style="width: 50px;"></div>
    </div>
    <div class="ld2-header__col ld2-header__col--actions">
      <div class="ld2-bone ld2-bone--header" style="width: 70px;"></div>
    </div>
  </div>

  <!-- ── Lignes skeleton ────────────────────────────────────────────────── -->
  <div
    *ngFor="let i of skeletonRows; let idx = index"
    class="ld2-row"
    [class.ld2-row--alt]="idx % 2 !== 0"
    [attr.aria-hidden]="true"
  >
    <!-- Colonne intervention -->
    <div class="ld2-row__col ld2-row__col--main">
      <!-- Indentation simulée aléatoire -->
      <div class="ld2-indent" [style.width.px]="[0,0,20,0,40,20][idx % 6]"></div>

      <!-- Icône toggle fantôme -->
      <div class="ld2-bone ld2-bone--icon" *ngIf="idx % 3 !== 2"></div>
      <div class="ld2-spacer" *ngIf="idx % 3 === 2"></div>

      <div class="ld2-text-block">
        <!-- Tag niveau -->
        <div class="ld2-bone ld2-bone--tag"
             [style.width.px]="[80,70,90,60,75,85][idx % 6]"></div>
        <!-- Titre ligne 1 -->
        <div class="ld2-bone ld2-bone--title"
             [style.width.%]="[85,70,90,60,78,68][idx % 6]"></div>
        <!-- Titre ligne 2 partielle (seulement pour certaines lignes) -->
        <div class="ld2-bone ld2-bone--title ld2-bone--title-2"
             *ngIf="idx % 4 === 1"
             [style.width.%]="45"></div>
      </div>
    </div>

    <!-- Colonne date début -->
    <div class="ld2-row__col ld2-row__col--date">
      <div class="ld2-date-card" *ngIf="idx % 5 !== 4">
        <div class="ld2-bone ld2-bone--date-icon"></div>
        <div class="ld2-bone ld2-bone--date-value"></div>
        <div class="ld2-bone ld2-bone--date-label"></div>
      </div>
    </div>

    <!-- Colonne date fin -->
    <div class="ld2-row__col ld2-row__col--date">
      <div class="ld2-date-card" *ngIf="idx % 5 !== 4">
        <div class="ld2-bone ld2-bone--date-icon"></div>
        <div class="ld2-bone ld2-bone--date-value"></div>
        <div class="ld2-bone ld2-bone--date-label"></div>
      </div>
    </div>

    <!-- Colonne actions -->
    <div class="ld2-row__col ld2-row__col--actions">
      <div class="ld2-bone ld2-bone--action-btn"></div>
      <div class="ld2-bone ld2-bone--action-btn"></div>
      <div class="ld2-bone ld2-bone--action-btn"></div>
    </div>
  </div>

  <!-- ── Message d'accessibilité (invisible visuellement) ──────────────── -->
  <span class="ld2-sr-only">Chargement des interventions en cours, veuillez patienter…</span>
</div>